import { useEffect } from 'react'

import { notification } from 'antd'
import { useUnit } from 'effector-react'

import './api-notifications.model'
import { notificationInstanceChanged } from './notifications-provider.model'

export const NotificationsProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [notificationInstance, contextHolder] = notification.useNotification()
  const setNotificationInstance = useUnit(notificationInstanceChanged)

  useEffect(() => {
    setNotificationInstance(notificationInstance)
  }, [notificationInstance, setNotificationInstance])

  return (
    <>
      {contextHolder}
      {children}
    </>
  )
}
